import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Select } from 'antd';
import styled from 'styled-components';
import ControlWithLabel from './ControlWithLabel';
import { CHARACTER_COUNT } from '../../constants/cmConstants';
import { validateCustomerIdInput } from '../utils/common';

const AttributeSearch = ({
  searchField,
  searchText,
  options,
  onSearch,
  onTabSwitch,
  size = 'small'
}) => {
  const [searchBy, setSearchBy] = useState(searchField);
  const [searchValue, setSearchValue] = useState(searchText);

  useEffect(() => {
    setSearchBy(searchField);
    setSearchValue(searchText);
  }, [onTabSwitch]);

  const onSearchButtonClick = () => {
    if (searchBy && searchValue.length > 0) {
      onSearch(searchBy, searchValue);
    }
  };

  const onDropdownChange = (optionValue) => {
    setSearchBy(optionValue);
    if (searchBy && optionValue === '') {
      setSearchValue('');
      onSearch('', '');
    }
  };

  const onSearchChange = (e) => {
    const value = e.target.value;

    if (searchBy === 'customer-id') {
      if (validateCustomerIdInput(value)) {
        setSearchValue(value);
      }
    } else {
      setSearchValue(value);
    }
  };

  return (
    <StyledControlWithLabel label="Search">
      <Input.Group compact>
        <StyledSelect
          value={searchBy || 'Search by'}
          size={size}
          onChange={onDropdownChange}
          dropdownStyle={{ width: '165px' }}>
          <Select.Option value="">Search by</Select.Option>
          {options.map(({ label, value, disabled }) => {
            return (
              <Select.Option disabled={disabled} key={value} value={value}>
                {label}
              </Select.Option>
            );
          })}
        </StyledSelect>
        <StyledSearch
          style={{ width: '190px' }}
          placeholder="Search"
          enterButton
          size={size}
          value={searchValue}
          onSearch={onSearchButtonClick}
          onChange={onSearchChange}
          buttonstatus={searchBy && searchValue?.length > 0 ? 0 : 1}
          disabled={searchBy === ''}
          maxLength={CHARACTER_COUNT}
          allowClear
        />
      </Input.Group>
    </StyledControlWithLabel>
  );
};

const StyledControlWithLabel = styled(ControlWithLabel)`
  float: right;
`;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }
  &&&.ant-select-open,
  &&&:not(.ant-select-disabled):hover {
    .ant-select-selector {
      border-color: #21b4bd;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
    }
  }
`;

const StyledSearch = styled(Input.Search)`
  .ant-input-search-button {
    border-radius: 0 4px 4px 0 !important;
  }
  .ant-input-search-button,
  .ant-input-search-button:hover,
  .ant-input-search-button:focus {
    background: ${(props) => (props.buttonstatus ? '#fff' : '#21b4bd')};
    border-color: ${(props) =>
      props.buttonstatus ? '1px solid #d9d9d9' : '#21b4bd'};
    color: ${(props) => (props.buttonstatus ? 'rgba(0, 0, 0, 0.25)' : '#fff')};
    cursor: ${(props) => (props.buttonstatus ? 'not-allowed' : 'pointer')};
  }
`;

AttributeSearch.propTypes = {
  searchField: PropTypes.string,
  searchText: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool
    })
  ),
  onSearch: PropTypes.func.isRequired,
  onTabSwitch: PropTypes.string
};

export default AttributeSearch;
